import { render, staticRenderFns } from "./OwnershipsEditor.vue?vue&type=template&id=82cf35c2&scoped=true"
import script from "./OwnershipsEditor.vue?vue&type=script&lang=js"
export * from "./OwnershipsEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82cf35c2",
  null
  
)

export default component.exports